import {action, observable} from 'mobx';
import {paramsTypes} from '../SignUpStore';
import { resetPassword } from '@/services/Forget';
import stores from '@/stores';
import log from '@/utils/log';

class ForgetStore {
  
  @observable userAccount: paramsTypes = {
        mobile: '',
        password: '',
        code: ''
    };
  
  @action.bound async forget () {
   
      const [ error ] = await resetPassword(this.userAccount)
      if (error) {
        log({pageId: 'P03', eventId: 'E0304',ext: ''})
        return
      }
    log({pageId: 'P03', eventId: 'E0306',ext: ''})
    window.localStorage.removeItem('userInfo'); // 修改密码后清除用户信息
      stores.routingStore.history.push('/');
  }
  
  @action.bound setUserAccount(userAccount: { [key: string]: string }) {
      this.userAccount = Object.assign({}, this.userAccount, userAccount);
  }
  
  
  
}

export default ForgetStore;
